import React from 'react';
import LoginComponent from '../../Auth/login';

export default function Login() {
  return <LoginComponent />;
}
